export default __webpack_public_path__ + "static/media/scarecrow-animated.61bc878f.gif";